var map = {
	"./about.jpg": 994,
	"./about1.jpg": 9704,
	"./banner1.png": 5361,
	"./banner2.png": 9418,
	"./banner3.png": 4989,
	"./banner4.png": 8876,
	"./bigImg.png": 9325,
	"./bigTeaImg.png": 8213,
	"./detail.png": 4696,
	"./dot1.png": 5057,
	"./dot2.png": 720,
	"./idea.png": 8493,
	"./img1.png": 5731,
	"./img2.png": 8681,
	"./img3.png": 6064,
	"./left.png": 1591,
	"./news1.png": 5135,
	"./news2.png": 7067,
	"./news3.png": 7493,
	"./news4.png": 2497,
	"./right.png": 7937,
	"./seriesCustomize.png": 7746,
	"./seriesFloor.png": 9667,
	"./seriesGift.png": 5412,
	"./seriesNewProduct.png": 9629,
	"./seriesTea.png": 6753,
	"./seriesXiangCha.png": 9104,
	"./time.png": 3231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3098;